import { render, staticRenderFns } from "./CreateOrUpdateGroup.vue?vue&type=template&id=0a2b048f&"
import script from "./CreateOrUpdateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports